import React from 'react';

import styled from 'styled-components';
import { IoInformationCircleOutline } from 'react-icons/io5';

import CustomTooltip from './CustomTooltip';

type Direction = 'row' | 'column';

const Wrapper = styled.div``;

const Layout = styled.div<{ $direction: Direction }>`
  display: flex;
  ${({ $direction }) =>
    $direction === 'row'
      ? {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }
      : {
          flexDirection: 'column',
          justifyContent: 'initial',
          alignItems: 'initial',
          gap: '6px',
        }}
`;

const LabelView = styled.div<{ $width?: number }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: ${(props) => (props.$width ? `${props.$width}px` : 'initial')};
`;

const Label = styled.label`
  display: block;
`;

const FlexBox = styled.div<{ $pos: string }>`
  width: ${(props) => (props.$pos === 'right' ? 'initial' : '100%')};
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Error = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: ${(props) => props.theme.global.errorColor};
`;

const TooltipView = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    font-size: 18px;
    color: ${(props) => props.theme.global.lightTextColor};
  }
`;

interface FormRowProps {
  label?: string;
  labelWidth?: number;
  name?: string;
  error?: string;
  direction?: Direction;
  pos?: 'left' | 'right';
  tooltipId?: string;
  tooltip?: string;
  children?: React.ReactNode;
}

const FormRow = ({
  label,
  labelWidth,
  tooltip,
  tooltipId,
  pos = 'right',
  name,
  error,
  direction = 'column',
  children,
}: FormRowProps) => {
  return (
    <Wrapper>
      <Layout $direction={direction}>
        {label && (
          <LabelView $width={labelWidth}>
            <Label {...(name && { htmlFor: name })}>{label}</Label>
            {tooltip && tooltipId && (
              <TooltipView className={tooltipId}>
                <IoInformationCircleOutline />
                <CustomTooltip anchorSelect={`.${tooltipId}`} place="bottom">
                  {tooltip}
                </CustomTooltip>
              </TooltipView>
            )}
          </LabelView>
        )}
        <FlexBox $pos={pos}>
          {React.cloneElement(children as any, { ...(error && { error }), ...(name && { id: name }) })}
        </FlexBox>
      </Layout>
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default FormRow;
